namespace TabAurous.Inventory {
    export interface LocationTransferForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        FromDepartmentId: Serenity.LookupEditor;
        ToDepartmentId: Serenity.LookupEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        TermsId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: LocationTransferItemsEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        RoundOff: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BillAddId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class LocationTransferForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.LocationTransfer';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LocationTransferForm.init)  {
                LocationTransferForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.DecimalEditor;
                var w7 = LocationTransferItemsEditor;
                var w8 = s.TextAreaEditor;

                Q.initFormType(LocationTransferForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'FromDepartmentId', w3,
                    'ToDepartmentId', w3,
                    'VoucherTypeId', w4,
                    'AutoPosting', w5,
                    'TermsId', w4,
                    'CurrencyId', w3,
                    'ExchRate', w6,
                    'EmployeeId', w4,
                    'ItemDetails', w7,
                    'Pieces', w4,
                    'Weight', w6,
                    'NetWeight', w6,
                    'Remark', w8,
                    'RoundOff', w4,
                    'CompanyId', w4,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BillAddId', w4,
                    'ShipmentId', w4,
                    'ShipAddressId', w4,
                    'UserId', w4,
                    'FinancialYearId', w4
                ]);
            }
        }
    }
}
